module.exports = __webpack_public_path__ + "static/media/logo.861b3b4f.svg";